import { Component, OnInit } from '@angular/core';
import { AdminService, AdminTotalsDto } from 'src/generated_client';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {

  totals: AdminTotalsDto = {};

  constructor(
    private adminService: AdminService
  ) {
  }

  ngOnInit() {

    this.adminService.apiAdminGetTotalsGet().subscribe(t => {
      this.totals = t;
    });
  }
}
